// extracted by mini-css-extract-plugin
export var buttonContent = "_4c-0";
export var centered = "_4c-1";
export var centeredFlex = "_4c-2";
export var errorText = "_4c-3";
export var icon = "_4c-4";
export var iconButtonContent = "_4c-5";
export var monospace = "_4c-6";
export var padded = "_4c-7";